// Slot'un gösterilecek/etkin fiyatını hesaplar (kuruş cinsinden).
//
// Üç fiyatlandırma modu vardır:
//   Özel     (priceOverride = 1)                    -> kullanıcının elle girdiği slotPrice kullanılır.
//   Otomatta (priceOverride = 0, slotPrice < 0)     -> fiyat 0; gerçek fiyat otomat üzerinde
//                                                       belirlenir. slotPrice DB'de sentinel (-1) tutulur.
//   Standart (priceOverride = 0, slotPrice = 0)     -> stoğun GÜNCEL liste fiyatı dinamik olarak
//                                                       kullanılır (slotPrice=0 sentinel). Stok fiyatı
//                                                       değişirse slot da takip eder.
//
// stockPriceMap: { [stockId]: stockPrice } — stok kartlarından türetilen güncel fiyat haritası.

// "Otomatta" modu için slotPrice sentinel değeri (etkin fiyat 0 anlamına gelir).
export const OTOMATTA_SLOT_PRICE = -1;

// Slot'un fiyat tipini döndürür: "ozel" | "otomatta" | "standart".
export function getSlotPriceType(row) {
  if (Number(row?.priceOverride) === 1) return "ozel";
  if (Number(row?.slotPrice) < 0) return "otomatta";
  return "standart";
}

export function getEffectiveSlotPrice(row, stockPriceMap) {
  // Özel: elle girilen fiyat.
  if (Number(row?.priceOverride) === 1) {
    return Number(row?.slotPrice) || 0;
  }
  // Otomatta: fiyat 0 (sentinel).
  if (Number(row?.slotPrice) < 0) {
    return 0;
  }
  // Standart: stoğun güncel liste fiyatı (dinamik).
  const stockPrice = stockPriceMap?.[row?.stockId];
  return stockPrice != null ? Number(stockPrice) : 0;
}
